import { useContext, useEffect, useState } from "react";
import { SearchContext } from "../../../Store/Search.store";
import styles from './searchFilters.module.css';
import { arrow_stroke } from "../../../assets/icons";

export default function OrderBy({text} : {text: string}) {
    const {searchData, setSearchData} = useContext(SearchContext);
    const [sortBy, setSortBy] = useState<number>(0);
    const [sortText, setSortText] = useState<string>("Relevance");
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
      document.querySelector("body")?.addEventListener("click", (e) => { 
        const element = e.target as HTMLElement;
        if (element.closest(`.${styles.sortby_container}`) === null) {
          setOpen(false);
        }
      });
    },[]);


    const handleSortBy = (sort: number) => {
        let sortedItems = searchData.data.items;
        setSortBy(sort);
        switch (sort) {
          case 0:
            setSortText("Relevance");
              sortedItems = sortedItems.sort((a, b) => b.alternativeLevel - a.alternativeLevel);
            break;
          case 1:
            setSortText("Most recent");
              sortedItems = sortedItems.sort((a, b) => new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime());
            break;
          case 2:
            setSortText("A-Z Supplier name");
            sortedItems = sortedItems.sort((a, b) => a.companyName.localeCompare(b.companyName));
            break;
          case 3:
            setSortText("Z-A Supplier name");
            sortedItems = sortedItems.sort((a, b) => b.companyName.localeCompare(a.companyName));
            break;
          case 4:
            setSortText("A-Z Ad title");
            sortedItems = sortedItems.sort((a, b) => a.title.localeCompare(b.title));
            break;
          case 5:
            setSortText("Z-A Ad title");
            sortedItems = sortedItems.sort((a, b) => b.title.localeCompare(a.title));
            break;
          default:
            break;
        }
  
        setSearchData({...searchData, data: {...searchData.data, items: sortedItems}});
      }

    return (
        <div className={styles.sortby_container}>
        <button onClick={() => setOpen(!open)} className={open ? styles.open : ""}><span>{text}</span> <span className={styles.sortText}>{sortText}</span> <i>{arrow_stroke}</i></button>
        <div className={`${open ? styles.open : ""} ${styles.sortbyFilters}`}>
            <ul>
                <li className={sortBy === 0 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(0)}>Relevance</button>
                </li>
                <li className={sortBy === 1 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(1)}>Most recent</button>
                </li>
                <li className={sortBy === 2 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(2)}>A-Z Supplier name</button>
                </li>
                <li className={sortBy === 3 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(3)}>Z-A Supplier name</button>
                </li>
                <li className={sortBy === 4 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(4)}>A-Z Ad title</button>
                </li>
                <li className={sortBy === 5 ? styles.activeSortBy : ""}>
                    <button onClick={() => handleSortBy(5)}>Z-A Ad title</button>
                </li>
            </ul>
        </div>
    </div>
    )
}